import gql from 'graphql-tag'

export const userSessionTokenQuery = () => gql`
  query userSessionToken {
    userSessionToken {
      token
    }
  }
`
